import alertTriangle from './alert-triangle.svg';
import checkCircle from './check-circle.svg';
import negative from './negative.svg';

export const ICONS_56PX_MAP = {
    alertTriangle,
    negative,
    checkCircle,
};
